import { render, staticRenderFns } from "./member.vue?vue&type=template&id=253c77aa&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"
import style0 from "./member.vue?vue&type=style&index=0&id=253c77aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c77aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\site\\online-photo\\image-upscaler-spa\\aiseesoft.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('253c77aa')) {
      api.createRecord('253c77aa', component.options)
    } else {
      api.reload('253c77aa', component.options)
    }
    module.hot.accept("./member.vue?vue&type=template&id=253c77aa&scoped=true", function () {
      api.rerender('253c77aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/member.vue"
export default component.exports